import {
    AggregateFunctions,
    AggregateQueryInterval,
    AggregateQueryMode,
    ApiQuery,
    ApiQueryEndpoints,
    Filter,
    FilterOperators,
} from "~/modules/filters/types";
import { MEASURE_SLUGS } from "~/consts";
import {
    VisualizationConfig,
    VisualizationMode,
    VisualizationModeTypes,
} from "~/modules/visualization/components/Timeseries/types";
import { FOUR_YEARS_AGO, TODAYS_DATE } from "~/utils/dates/consts";
import { TOKEN_TIMESERIES_V4_API_TOOLS_CONTROLS } from "~/modules/visualization/components/Timeseries/consts";
import { TokenTimeseriesColumns, TokenTimeseriesGroupBy } from "../types";
import { ExportTableNames } from "~/modules/downloads/types";

// // // //

const BASE_QUERY: ApiQuery = {
    sort: {
        direction: "asc",
        field: "date",
    },
    pagination: {
        page: 1,
        perPage: 25,
    },
};

const visualizationConfig: VisualizationConfig = {
    area: true,
    enableZoom: false,
    showTotal: true,
    height: 350,
    legend: {
        itemWidth: 125,
        layout: "vertical",
        align: "right",
        verticalAlign: "top",
    },
};

// // // //

export function getTransferCountChart(props: {
    key: string;
    filters: Filter[];
    defaultGroupBy: TokenTimeseriesGroupBy;
    enableGroupByControls: boolean;
    groupByOptions: TokenTimeseriesGroupBy[];
}): VisualizationMode {
    const {
        key,
        filters,
        enableGroupByControls,
        defaultGroupBy,
        groupByOptions,
    } = props;
    return {
        key,
        type: VisualizationModeTypes.area,
        loginRequired: true,
        content: {
            label: "Transfer Count",
        },
        visualizationConfig: {
            ...visualizationConfig,
            showTotal: true,
        },
        visualizationControls: {
            stacked: {
                enabled: false,
                active: false,
                forceUpdate: true,
            },
            legend: {
                enabled: true,
                active: true,
                forceUpdate: true,
            },
            navigator: {
                enabled: true,
                active: true,
                forceUpdate: true,
                xAxis: {
                    min: Number(FOUR_YEARS_AGO),
                    max: Number(TODAYS_DATE),
                },
            },
        },
        endpoint: ApiQueryEndpoints.TokenTimeseriesV4,
        query: {
            ...BASE_QUERY,
            aggregate: {
                aggregateFunction: AggregateFunctions.Sum,
                groupBy: defaultGroupBy,
                mode: AggregateQueryMode.flow,
            },
            filter: {
                operator: FilterOperators.And,
                filters: [
                    ...filters,
                    {
                        field: TokenTimeseriesColumns.measureSlug,
                        operator: FilterOperators.Equals,
                        value: MEASURE_SLUGS.number_of_daily_transactions_count,
                    },
                ],
            },
        },
        queryControls: {
            groupBy: {
                enabled: enableGroupByControls,
                forceUpdate: true,
                value: defaultGroupBy,
                allowedOptions: groupByOptions,
            },
            interval: {
                enabled: true,
                forceUpdate: true,
                value: AggregateQueryInterval.week,
                allowedOptions: [
                    AggregateQueryInterval.day,
                    AggregateQueryInterval.week,
                    AggregateQueryInterval.month,
                    AggregateQueryInterval.quarter,
                    AggregateQueryInterval.year,
                ],
            },
        },
        apiTools: TOKEN_TIMESERIES_V4_API_TOOLS_CONTROLS,
        dataExportControls: {
            enabled: true,
            filename: key,
            exportTableName: ExportTableNames.token_timeseries_v4,
        },
    };
}
